const SESSION_TOKEN_PARAM = "token";

export const buildConsentOrigin = (pathname: string, search: string): string => {
  const params = new URLSearchParams(search);
  params.delete(SESSION_TOKEN_PARAM);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};
